// extracted by css-extract-rspack-plugin
export default {"lastQuestion":"last-question--Ro1mJiZO2omqIBp8"};